<div class="wrapper wrapper-content mtv-parcels-page row">
    <div class="ibox mainPartPage" [ngStyle]="{width: parcelsService.showDetailedView ? 'calc(100% - 420px)' : ''}">
        <div class="ibox-content">
            <div class="row">
                <div class="col-sm-7">
                    <filter [tabHeading]="'Parcels'" [buildings]="parcelsService.buildingsForRead"></filter>
                </div>

                <parcels-filter></parcels-filter>

                <div class="col-sm-3 input-group-btn pull-right" style="right: 35px;"
                     *ngIf="parcelsService.account.canUpdate(parcelsService.serviceName)">
                    <button class="btn btn-w-m btn-primary pull-right"
                            style="border-radius: 3px 0 0 3px;"
                            type="button"
                            (click)="parcelsService.isParcelModalShow = true">
                        <i class="fa fa-plus-circle"></i> New Parcel
                    </button>
                    <button data-toggle="dropdown"
                            class="btn btn-primary dropdown-toggle"
                            type="button"
                            aria-expanded="false">
                        <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu pull-right" style="z-index: 1001; right: -18px;">
                        <li (click)="parcelsService.isMassParcelModalShow = true"><a>Multiple New Parcels</a></li>
                    </ul>
                </div>

            </div>
            <div class="row">
                <div class="col-sm-12">
                    <filters-view></filters-view>
                </div>
            </div>
            <tabs-wrapper>
                <tab-item [tabId]="'allParcels'" [ngClass]="{'sk-loading': parcelsService.spinnerShow}">
                    <parcels-list></parcels-list>
                </tab-item>
                <pagination *ngIf="parcelsService.data.allParcels.total && urlService.queryParams['page']"
                            [total]="parcelsService.data['allParcels'].total">
                </pagination>
                <spinner [spinnerShow]="parcelsService.spinnerShow"></spinner>
            </tabs-wrapper>
        </div>
        <div *ngIf="parcelsService.showDetailedView" class="animated animated-directory slideInRight detailed-view dv-sidebar">
            <parcel-detailed-view *ngIf="parcelsService.showDetailedView"></parcel-detailed-view>
        </div>
    </div>
</div>

<parcel-modal          *ngIf="parcelsService.isParcelModalShow"></parcel-modal>
<parcel-mass-modal     *ngIf="parcelsService.isMassParcelModalShow"></parcel-mass-modal>
<transit-parcel-modal  *ngIf="parcelsService.isTransitModalShow"></transit-parcel-modal>
<parcel-history        *ngIf="parcelsService.isParcelHistoryModalShow"></parcel-history>
<parcel-reminder-modal *ngIf="parcelsService.isParcelReminderModalShow"></parcel-reminder-modal>
<capture-image-modal   *ngIf="parcelsService.showImageCaptureModal"
                       (onClose)="parcelsService.onImageCaptureModalClose($event)">
</capture-image-modal>



// WEBPACK FOOTER //
// /app/src/app/views/parcels/parcels.component.html